import React, { useState } from 'react'
import UpdatePlan from './updatePlan'
import BillingHistoryAdmin from '../../components/subscription/billingHistory'
import PlanHistory from '../../components/subscription/planHistory'
import { usePlan } from '../../context/PlanContext'

const formatDate = (dateString: any) => {
  const date = new Date(dateString)
  const day = date.getDate().toString().padStart(2, '0')
  const month = (date.getMonth() + 1).toString().padStart(2, '0')
  const year = date.getFullYear()
  return `${day}/${month}/${year}`
}

const Index: React.FC<any> = () => {
  const [selectTab, setSelectedTab] = useState<any>('billingHistory')
  const { currentPlan } = usePlan()

  const startDate = currentPlan?.startDate ? formatDate(currentPlan.startDate) : 'N/A'
  const endDate = currentPlan?.endDate ? formatDate(currentPlan.endDate) : 'N/A'

  let content
  if (selectTab === 'updatePlan') {
    content = <UpdatePlan />
  } else if (selectTab === 'billingHistory') {
    content = <BillingHistoryAdmin />
  } else {
    content = <PlanHistory />
  }

  return (
    <div className='maincontainer'>
      <div className='card mb-5 mb-xl-5'>
        <div id='kt_billing_payment_tab_content' className='card-body tab-content'>
          {/* Credit Card Tab panel */}
          <div
            id='kt_billing_creditcard'
            className='tab-pane fade active show'
            role='tabpanel'
            aria-labelledby='kt_billing_creditcard_tab'
          >
            {/* Title */}
            <h3 className='mb-5'>Current Plan Detail</h3>

            {/* Cards */}
            <div className='row gx-9 gy-6'>
              <div className='col-xl-8'>
                <div className='card card-dashed h-xl-100 flex-row flex-stack flex-wrap p-6'>
                  <div className='flex-grow-1'>
                    <div className='d-flex justify-content-between align-items-start flex-wrap mb-2'>
                      <div className='d-flex flex-column'>
                        <div className='d-flex align-items-center mb-2'>
                          <div className='text-gray-900 text-hover-primary fs-2 fw-bold me-2'>
                            {currentPlan?.client?.users[0]?.name}
                          </div>
                          <i className='ki-outline bi bi-patch-check fs-1 text-primary'></i>
                        </div>
                      </div>
                    </div>
                    <div className='d-flex flex-wrap flex-stack'>
                      <div className='d-flex flex-column flex-grow-1 pe-8'>
                        <div className='d-flex flex-wrap'>
                          <div className='border border-gray-300 border-dashed rounded min-w-200px py-3 px-4 me-6 mb-3'>
                            <div className='d-flex align-items-center'>
                              <i className='ki-outline bi-rocket fs-3 text-primary me-2'></i>
                              <div className='fs-2 fw-bold counted'>
                                {currentPlan?.package?.package?.packageName.replace(/_/g, ' ')}
                              </div>
                            </div>
                            <div className='fw-semibold fs-6 text-gray-400'>
                              Current Billing Plan
                            </div>
                          </div>
                          <div className='border border-gray-300 border-dashed rounded min-w-200px py-3 px-4 me-6 mb-3'>
                            <div className='d-flex align-items-center'>
                              <i className='ki-outline bi-sunrise fs-3 text-primary me-2'></i>
                              <div className='fs-2 fw-bold counted'>{startDate}</div>
                            </div>
                            <div className='fw-semibold fs-6 text-gray-400'>Plan Start Date</div>
                          </div>
                          {/* <div className='border border-gray-300 border-dashed rounded min-w-200px py-3 px-4 me-6 mb-3'>
                            <div className='d-flex align-items-center'>
                              <i className='ki-outline bi-sunrise fs-3 text-primary me-2'></i>
                              <div className='fs-2 fw-bold counted'>25/05/2025</div>
                            </div>
                            <div className='fw-semibold fs-6 text-gray-400'>
                              Last Renewal Reminder
                            </div>
                          </div> */}
                          <div className='border border-gray-300 border-dashed rounded min-w-200px py-3 px-4 me-6 mb-3'>
                            <div className='d-flex align-items-center'>
                              <i className='ki-outline bi-sunrise fs-3 text-primary me-2'></i>
                              <div className='fs-2 fw-bold counted'>{endDate}</div>
                            </div>
                            <div className='fw-semibold fs-6 text-gray-400'>Plan Expiry Date</div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* Card 1 */}
            </div>

            {/* Buttons */}
            <div className='d-flex justify-content-end mt-4'>
              <button
                className={`btn ${
                  selectTab === 'billingHistory' ? 'btn-secondary' : 'btn-primary'
                } me-2`}
                onClick={() => setSelectedTab('billingHistory')}
              >
                Billing History
              </button>
              <button
                className={`btn ${
                  selectTab === 'updatePlan' ? 'btn-secondary' : 'btn-primary'
                } me-2`}
                onClick={() => setSelectedTab('updatePlan')}
              >
                Update Plan
              </button>
              <button
                className={`btn ${
                  selectTab === 'planHistory' ? 'btn-secondary' : 'btn-primary'
                } me-2`}
                onClick={() => setSelectedTab('planHistory')}
              >
                Plan History
              </button>
            </div>
          </div>
        </div>
      </div>
      <div className='card mb-xl-10'>{content}</div>
    </div>
  )
}

export default Index
